export const oneOnOneReportSelector = state => state.oneOnOneReport;
